import { Injectable, inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';

@Injectable({ providedIn: 'root' })
export class UserContextService {

  private auth = inject(Auth);
  private firestore = inject(Firestore);

  private _name: string | null = null;

  async loadUserName(): Promise<string | null> {

    if (this._name) return this._name;

    const user = this.auth.currentUser;
    if (!user) return null;

    const snap = await getDoc(
      doc(this.firestore, 'users', user.uid)
    );

    this._name = snap.exists()
      ? snap.data()?.['name'] ?? null
      : null;

    return this._name;
  }

  get name(): string | null {
    return this._name;
  }
}
